var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 2.333a.208.208 0 00-.167-.204l-.041-.004H6.334a.208.208 0 00-.209.208v1.875h3.75V2.333zM3.623 14.781l.002.052a1.041 1.041 0 001.042 1.042h6.667a1.041 1.041 0 001.041-1.042l.003-.052.777-9.323H2.845l.778 9.323zm2.085-1.614v-5a.625.625 0 111.25 0v5a.625.625 0 01-1.25 0zm3.334 0v-5a.625.625 0 111.25 0v5a.625.625 0 01-1.25 0zm2.083-8.959h3.542a.625.625 0 110 1.25h-.259l-.785 9.427a2.29 2.29 0 01-2.29 2.24H4.668a2.291 2.291 0 01-2.29-2.24l-.785-9.427h-.259a.625.625 0 110-1.25h3.542V2.333A1.458 1.458 0 016.333.875h3.334l.144.007a1.458 1.458 0 011.314 1.451v1.875z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c912df307eb95124f49b9dbc3496ff52.svg";
export { ForwardRef as ReactComponent };